import { useMutation } from '@apollo/client'
import { createNote as createNoteGql } from 'src/graphql/mutations/createNote.gql'

const useCreateNote = (mutationHookOptions) => {
   const [createNote, { called, client, data, error, loading }] = useMutation(createNoteGql, {
      refetchQueries: ['getNoteList'],
      ...mutationHookOptions
   })

   const wrappedMutationFn = (input, mutationFnOptions) => createNote({
      variables: { input },
      ...mutationFnOptions
   })

   return {
      createNote: wrappedMutationFn,
      called,
      client,
      error,
      mutating: loading,
      result: data
   }
}

export default useCreateNote
